export const selectPreferredCurrency = (state) => state.User?.preferredCurrency || "RON";
export const selectUserProfile = (state) => state.User?.userProfile || null;
